import React, { Suspense } from "react";
import Loader from "components/loader";
import { Routes, Route } from "react-router-dom";
import Home from "pages/home";
import Error404 from "pages/error-404";
/* PLOP_IMPORT_ROUTES */
import Reassessments from "pages/reassessments";
import CorrectionsApprovalBatchDetails from "pages/corrections-approval-batch-details";
import CorrectionsApprovals from "pages/corrections-approvals";
import Corrections from "pages/corrections";
import Notifications from "pages/notifications";
import ApprovalBatchDetails from "pages/approval-batch-details";
import References from "pages/references";
import Approvals from "pages/approvals";
import AmbiguousExceptions from "pages/ambiguous-exceptions";
import ApttusExceptions from "pages/apttus-exceptions";
import { RouteGuard } from "./RouteGuard";
import { isNonProdEnvironment } from "utils/environment";

const FXRateApprovals = React.lazy(
  () => import("pages/reassessments/FXRateApprovals")
);

const Router: React.FC = (): JSX.Element => {
  return (
    <Suspense fallback={<Loader loadingText="Loading..." />}>
      <Routes>
        <Route path="" element={<RouteGuard />}>
          <Route path="" element={<Home />} />
          <Route path="apttus-exceptions" element={<ApttusExceptions />} />
          <Route
            path="ambiguous-exceptions"
            element={<AmbiguousExceptions />}
          />
          <Route path="approvals">
            <Route path="" element={<Approvals />} />
            <Route path="corrections">
              <Route path="" element={<CorrectionsApprovals />} />
              <Route
                path=":batchId"
                element={<CorrectionsApprovalBatchDetails />}
              />
            </Route>
            <Route path=":batchId" element={<ApprovalBatchDetails />} />
          </Route>
          <Route path="references" element={<References />} />
          <Route path="fxRateApprovals" element={<FXRateApprovals />} />
        </Route>
        {/* PLOP_INJECT_ROUTES */}
        {isNonProdEnvironment && (
          <>
            <Route path="/reassessments" element={<Reassessments />} />
          </>
        )}
        <Route path="/corrections" element={<Corrections />} />
        <Route path="/notifications" element={<Notifications />} />

        {/* Must be the last route */}
        <Route path="*" element={<Error404 />} />
      </Routes>
    </Suspense>
  );
};

export default Router;
